import * as React from "react"
import Footer from "./Footer"
import Header from "./Header"
import useSiteMetadata from "../utils/SiteMetadata"
import { ReactNode } from "react"
import "../../styles/main.scss"
import { Seo } from "../common/Seo"
import useScroll from "../utils/Scroll"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faChevronUp } from "@fortawesome/free-solid-svg-icons"

interface SeoInterface {
  title?: string
  description?: string
  keywords?: Array<string>
  image?: string
  siteUrl?: string
  hasNoSpring?: boolean
}
interface Props {
  children: ReactNode
  className?: string
  seo?: any
  hideNewsletter?: boolean
}

const mergeMetadata = (generic: any, specific?: any): SeoInterface => {
  const meta = { ...generic }
  if (!specific) {
    return meta
  }
  if (specific?.title) {
    meta.title = specific.title
  }
  if (specific?.description) {
    meta.description = specific?.description
  }
  if (specific?.keywords && specific?.keywords?.length > 0) {
    meta.keywords = specific.keywords
  }
  if (specific?.hasNoSpring) {
    meta.hasNoSpring = true
  }
  return meta
}

const Layout = ({ children, className, seo, hideNewsletter }: Props) => {
  const metadata = mergeMetadata(useSiteMetadata(), seo)
  const scroll = useScroll()
  return (
    <div>
      <a href="#main" className="skip-to-main-content">
        Skip to main content
      </a>
      <Seo metadata={metadata} />
      {
        <div className="springone-banner">
          <div>
            <a href="https://www.vmware.com/explore/us/springone">
              Register for SpringOne at Explore 2025!
            </a>{" "}
          </div>
        </div>
      }
      <Header />
      <div className={`main ${className}`} id="main" role="main">
        {children}
      </div>
      <Footer hideNewsletter={hideNewsletter} />
      <div className={`anchor-to-header ${scroll.y > 800 ? "is-active" : ""}`}>
        <a className="animate-anchor" href="#header">
          <FontAwesomeIcon icon={faChevronUp} />
        </a>
      </div>
    </div>
  )
}

export default Layout
